import PaymentRegistrationView from './PaymentRegistrationView';
import { PaymentRegistrationProvider } from '@context/Payment/PaymentRegistration';

const PaymentRegistration = () => {
  return (
    <PaymentRegistrationProvider>
      <PaymentRegistrationView />
    </PaymentRegistrationProvider>
  );
};

export default PaymentRegistration;
